import * as Yup from 'yup'

import { LANDSCAPE_LOGO, longHeadlineMaxLength } from '../../fields'
import { generalGoogleAdValidation, listOfImagesShape } from '../../validations'
import { LONG_HEADLINE } from './fields'

export const validationSchema = Yup.object({
  ...generalGoogleAdValidation,
  [LANDSCAPE_LOGO]: listOfImagesShape,
  [LONG_HEADLINE]: Yup.string()
    .max(longHeadlineMaxLength, `Long headline should have maximum ${longHeadlineMaxLength} characters`)
    .required('This field should not be empty')
})
